<template>
	<div>
		<b-modal
			hide-footer
			id="modalVerViolacoes"
			title="Situações de Violação de Direitos"
			centered
		>
			<table class="table table-bordered table-sm table-striped">
				<tr>
					<td>Protocolo: {{ dados.protocolo }}</td>
					<td>Data: {{ dados.cadastrado }}</td>
				</tr>
				<tr v-if="dados.usuario">
					<td colspan="2">
						Vítima:
						{{ dados.usuario.nome_completo }}
					</td>
				</tr>
			</table>
			<h4>Situações</h4>
			<ol>
				<li v-for="item in itens" :key="item.id">
					{{ item.descricao }}
				</li>
			</ol>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: "ModalVerViolacoes",
	props: {
		itens: Array,
		dados: Object,
	},
};
</script>
